module.exports = __webpack_public_path__ + "static/media/shopify-password.5e056a4c.svg";